import React, { ReactNode } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';

interface EntrySectionProps {
  title: string;
  children: ReactNode;
  id?: string;
}

export const EntrySection: React.FC<EntrySectionProps> = ({
  title,
  children,
  id,
}: EntrySectionProps) => {
  const ref = useScrollReveal();

  return (
    <div className="entry-section" id={id} ref={ref}>
      <h3 className="entry-section-title">{title}</h3>
      {children}
    </div>
  );
};
